import React from 'react';

//STYLES
import { ContainerInfosMalha, ItemInfoMalha } from './styled';

interface PropsInfosMalha {
    /** Área do talhão em hectares, já calculada pelo pai. */
    talhao_area: number
    /** Quantidade de pontos da malha. */
    total_pontos: number
    /** Pontos que ainda não pertencem a nenhuma análise. */
    pontos_nunca_usados: number
    /** `flutuante` = barra sobre o mapa (padrão); `sidebar` = header da tela cheia. */
    variante?: 'flutuante' | 'sidebar'
    /** Ações à direita (ex.: botão de tela cheia). */
    children?: React.ReactNode
}

/**
 * Bloco de informações da malha: área, grid amostral e quantidade de pontos —
 * container incluso.
 *
 * Conteúdo único usado nos dois layouts; quem usa escolhe apenas a `variante`. Na
 * sidebar os rótulos são abreviados para caber na largura menor. Antes havia duas
 * cópias deste bloco, que já tinham divergido na unidade do grid.
 */
export const InfosMalha: React.FC<PropsInfosMalha> = ({ talhao_area, total_pontos, pontos_nunca_usados,
    variante = 'flutuante', children
}) => {

    const grid_amostral = total_pontos > 0 ? (total_pontos / talhao_area).toFixed(2) : 0
    const compacto = variante === 'sidebar'
    /* Malha inteira coberta: o número deixa de ser um alerta e passa a ser a confirmação. */
    const tudo_usado = pontos_nunca_usados === 0

    return (
        <ContainerInfosMalha $variante={variante}>
            <ItemInfoMalha>
                <label>{compacto ? 'Área' : 'Área do talhão'}</label>
                <p>{talhao_area} ha</p>
            </ItemInfoMalha>
            <ItemInfoMalha>
                <label>{compacto ? 'Pontos' : 'Total de pontos'}</label>
                <p>{total_pontos}</p>
            </ItemInfoMalha>
            <ItemInfoMalha>
                <label>Grid amostral</label>
                <p>{grid_amostral} ponto/ha</p>
            </ItemInfoMalha>
            <ItemInfoMalha $destaque={!tudo_usado}>
                <label>{compacto ? 'Sem análise' : 'Pontos sem análise'}</label>
                <p>{tudo_usado ? 'Nenhum' : pontos_nunca_usados}</p>
            </ItemInfoMalha>
            {children}
        </ContainerInfosMalha>
    )
}
